module.exports = __webpack_public_path__ + "media/country_flags/im-ee31a78b.png";